import { useMemo } from 'react';
import { propertyGroupsToPropertyDefinitions } from '../utils/properties';
import useFetchPropertyGroups from 'marketing-platform-lib/hooks/useFetchPropertyGroups';

/**
 * Fetch CRM object properties.
 * We use these properties to render the correct label + value representation (strings, number, date...)
 */
export default function useFetchCrmObjectProperties(objectTypeId, {
  skip
} = {
  skip: false
}) {
  const {
    data,
    loading,
    error
  } = useFetchPropertyGroups(objectTypeId, {
    skip
  });
  const propertyGroups = useMemo(() => {
    if (!data || data.length === 0) {
      return [];
    }
    return data;
  }, [data]);
  return useMemo(() => {
    return {
      properties: propertyGroupsToPropertyDefinitions(propertyGroups),
      propertyGroups,
      loading,
      error
    };
  }, [error, loading, propertyGroups]);
}